import { useQuery } from '@tanstack/react-query';

interface HostnameContext {
  hostname: string;
  isStorefront: boolean;
  isAdminApp: boolean;
}

export function useHostnameContext() {
  const { data, isLoading, isError } = useQuery<HostnameContext>({
    queryKey: ['/api/context'],
    staleTime: Infinity,
    retry: 3,
  });

  // Always show Home page regardless of hostname
  const fallbackIsStorefront = false;

  return {
    hostname: data?.hostname || (typeof window !== 'undefined' ? window.location.hostname : ''),
    isStorefront: isError ? fallbackIsStorefront : (data?.isStorefront || false),
    isAdminApp: isError ? !fallbackIsStorefront : (data?.isAdminApp || true),
    isLoading,
    isError,
  };
}
